import React, { useState } from 'react';

import './BettingPanelInstructions.css';

const BettingPanelInstructions = props => {

	const { handleCloseInstructions } = props;
	const [showNextInstructionsClassName, setShowNextInstructionsClassName] = useState('');

	const handleClose = evt => {
		handleCloseInstructions(evt);
	}

	const handleNext = evt => {
		setShowNextInstructionsClassName(' next');
	}

	return (
		<div className={"crg-overlay-panel"}>
			<div className={"crg-overlay-content crg-betting-panel-instructions"}>
				<div className="host" />
				<div className={"crg-msg-container " + showNextInstructionsClassName}>
					<div className="close-btn" onClick={handleClose}>X</div>

					<h3>
						How to Play
					</h3>
					<ol>
						<li>
						Place your wager by selecting a coin.
						<div>
							<img src="images/instructions_coins.png" />
						</div>
						</li>
						<li>
						Select a word chain.
						<div>
							<img src="images/instructions_word_chain.png" />
						</div>
						</li>
						<li>
						Solve the word chain by typing your answer.
						<div>
							<img src="images/instructions_solve.png" />
						</div>
						</li>
						<li>
						To win the game: solve all the word chains.
						</li>
					</ol>
					<div className="instructions-nav">
						<a onClick={handleNext} className="next">Next</a>
						<a onClick={handleClose} className="play-now">Play Now</a>
					</div>
				</div>
			</div>
		</div>
		);
}

export default BettingPanelInstructions;



// WEBPACK FOOTER //
// ./src/components/ChainReactionGame/BettingPanelInstrucitons.jsx